import { render, staticRenderFns } from "./OfferProductsList.vue?vue&type=template&id=a85c77c0&scoped=true"
import script from "./OfferProductsList.vue?vue&type=script&lang=js"
export * from "./OfferProductsList.vue?vue&type=script&lang=js"
import style0 from "./OfferProductsList.vue?vue&type=style&index=0&id=a85c77c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85c77c0",
  null
  
)

export default component.exports